class FruechteboxGesamttotal extends HTMLElement {
  constructor() {
    super();

    this.moneyFormat = this.dataset.moneyFormat;
    this.shippingPrice = document.querySelector("fruechtebox-regularity[data-shipping-price]").dataset.shippingPrice;
    this.gesamttotalInput = document.querySelector('[name="contact[gesamttotal]"]');
  }

  connectedCallback() {
    this.fruechteboxRadiosElement = document.querySelector("fruechtebox-radios");
    this.fruechteboxAddOnsElement = document.querySelector("featured-add-ons-recap");
    this.regularityElement = document.querySelector("fruechtebox-regularity");
  }

  updateTotal() {
    const fruechteboxPrice = this.fruechteboxRadiosElement.currentVariant.price;
    const fruechteboxAddOnsPrice = this.fruechteboxAddOnsElement.fearedAddOnsSubtotal || 0;
    const regularity = this.regularityElement.regularity;

    const newTotal = (parseInt(fruechteboxPrice) + parseInt(this.shippingPrice)) * regularity + parseInt(fruechteboxAddOnsPrice);

    const totalFormatted = this.moneyFormat.replace("{{amount}}", (newTotal / 100).toFixed(2));

    this.textContent = totalFormatted;
    this.gesamttotalInput.value = totalFormatted;
  }
}

customElements.define('fruechtebox-gesamttotal', FruechteboxGesamttotal);
